<div class="general-settings">
  <nav class="vertical-nav">
    <button
      (click)="activeSection.set('audio')"
      class="{{ activeSection() === 'audio' ? 'active' : '' }}">
      <fa-duotone-icon
        [icon]="faHeadset"
        [andorTooltip]="'Audio Settings' | translate"
        tooltipPosition="right"></fa-duotone-icon>
    </button>
    <button
      (click)="activeSection.set('video')"
      class="{{ activeSection() === 'video' ? 'active' : '' }}">
      <fa-duotone-icon
        [icon]="faCameraMovie"
        [andorTooltip]="'Video Settings' | translate"
        tooltipPosition="right"></fa-duotone-icon>
    </button>
    <button
      (click)="activeSection.set('misc')"
      class="{{ activeSection() === 'misc' ? 'active' : '' }}">
      <fa-duotone-icon
        [icon]="faCogs"
        [andorTooltip]="'General Settings' | translate"
        tooltipPosition="right"></fa-duotone-icon>
    </button>
    <button
      (click)="activeSection.set('profile')"
      class="{{ activeSection() === 'profile' ? 'active' : '' }}">
      <fa-duotone-icon
        [icon]="faUser"
        [andorTooltip]="'Profile' | translate"
        tooltipPosition="right"></fa-duotone-icon>
    </button>
    @if (developerMode()) {
      <button
        (click)="activeSection.set('developer')"
        class="{{ activeSection() === 'developer' ? 'active' : '' }}">
        <fa-duotone-icon
          [icon]="faCode"
          [andorTooltip]="'Development Settings' | translate"
          tooltipPosition="right"></fa-duotone-icon>
      </button>
    }
    @if (appStore.isConnectedView$ | async) {
      <button
        [disabled]="appService.maintenance.active()"
        (click)="activeSection.set('login')"
        class="{{ activeSection() === 'login' ? 'active' : '' }}">
        <fa-duotone-icon
          [icon]="faKey"
          [andorTooltip]="'Authentication' | translate"
          tooltipPosition="right"></fa-duotone-icon>
      </button>
    }
    @if (permissionStore.editAppSettings$ | async) {
      <button
        [disabled]="appService.maintenance.active()"
        (click)="activeSection.set('app')"
        class="{{ activeSection() === 'app' ? 'active' : '' }}">
        <fa-duotone-icon
          [icon]="faPenPaintbrush"
          [andorTooltip]="'App Settings' | translate"
          tooltipPosition="right"></fa-duotone-icon>
      </button>
    }
    @if (permissionStore.editAppPermissions$ | async) {
      <button
        [disabled]="appService.maintenance.active()"
        (click)="activeSection.set('permissions')"
        class="{{ activeSection() === 'permissions' ? 'active' : '' }}">
        <fa-duotone-icon
          [icon]="faUsers"
          [andorTooltip]="'Permission Settings' | translate"
          tooltipPosition="right"></fa-duotone-icon>
      </button>
    }
    @if (permissionStore.kickUser$ | async) {
      <button
        [disabled]="appService.maintenance.active()"
        (click)="activeSection.set('bans')"
        class="{{ activeSection() === 'bans' ? 'active' : '' }}">
        <fa-duotone-icon
          [icon]="faBan"
          [andorTooltip]="'Banned Users' | translate"
          tooltipPosition="right"></fa-duotone-icon>
      </button>
    }
    @if (permissionStore.manageRooms$ | async) {
      <button
        [disabled]="appService.maintenance.active()"
        (click)="activeSection.set('rooms')"
        class="{{ activeSection() === 'rooms' ? 'active' : '' }}">
        <fa-duotone-icon
          [icon]="faDoorOpen"
          [andorTooltip]="'Rooms' | translate"
          tooltipPosition="right"></fa-duotone-icon>
      </button>
    }
  </nav>
  <section
    class="content"
    [attr.inert]="
      appService.maintenance.active() &&
      ['app', 'permissions', 'bans', 'rooms', 'login'].includes(activeSection())
        ? ''
        : null
    ">
    @switch (activeSection()) {
      @case ('audio') {
        <andor-fieldset [headline]="'Audio Settings' | translate" size="fill">
          <andor-settings-audio></andor-settings-audio>
        </andor-fieldset>
      }
      @case ('video') {
        <andor-fieldset [headline]="'Video Settings' | translate" size="fill">
          <andor-settings-video></andor-settings-video>
        </andor-fieldset>
      }
      @case ('app') {
        <andor-app-settings></andor-app-settings>
      }
      @case ('permissions') {
        <andor-settings-permissions></andor-settings-permissions>
      }
      @case ('bans') {
        <andor-settings-bans></andor-settings-bans>
      }
      @case ('rooms') {
        <andor-settings-rooms></andor-settings-rooms>
      }
      @case ('misc') {
        <andor-fieldset [headline]="'General Settings' | translate" size="fill">
          <andor-settings-general></andor-settings-general>
        </andor-fieldset>
      }
      @case ('profile') {
        <andor-fieldset [headline]="'Profile' | translate" size="fill">
          <andor-settings-profile></andor-settings-profile>
        </andor-fieldset>
      }
      @case ('login') {
        <andor-fieldset [headline]="'Authentication' | translate" size="fill">
          <andor-user-login></andor-user-login>
        </andor-fieldset>
      }
      @case ('developer') {
        <andor-fieldset [headline]="'Development Settings' | translate" size="fill">
          <andor-settings-developer></andor-settings-developer>
        </andor-fieldset>
      }
    }
  </section>
</div>
